import { Flex } from "@redotech/arbiter/flex";
import { RedoTextInput } from "@redotech/arbiter/input/redo-text-input";
import { groupInput, input, InputSchema } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";

export const EcomExpressCarrierInput = groupInput({
  accountNumber: input<string>({ validator: nonEmptyValidator }),
  apiKey: input<string>({ validator: nonEmptyValidator }),
});

export type EcomExpressCarrierValue = InputSchema.Value<
  typeof EcomExpressCarrierInput
>;

export type EcomExpressCarrierForm = InputSchema.Input<
  typeof EcomExpressCarrierInput
>;

export const EcomExpressCarrierDefault = (): EcomExpressCarrierValue => ({
  accountNumber: "",
  apiKey: "",
});

export const CreateEcomExpressCarrierForm = memo(
  function CreateEcomExpressCarrierForm({
    carrierInput,
  }: {
    carrierInput: EcomExpressCarrierForm;
  }) {
    return (
      <Flex dir="column">
        <RedoTextInput
          label="Account number"
          placeholder=""
          setValue={carrierInput.inputs.accountNumber.setValue}
          value={carrierInput.inputs.accountNumber.value}
        />
        <RedoTextInput
          label="API key"
          placeholder=""
          setValue={carrierInput.inputs.apiKey.setValue}
          value={carrierInput.inputs.apiKey.value}
        />
      </Flex>
    );
  },
);
